import React from 'react';
import { RemoteAlertGroup } from '../../types/remoteAlerts';

interface RemoteAlertGroupTableProps {
  alertGroups: RemoteAlertGroup[];
  onAddGroup: () => void;
  onEditGroup: (group: RemoteAlertGroup) => void;
  onDeleteGroup: (groupId: string) => void;
}

const RemoteAlertGroupTable: React.FC<RemoteAlertGroupTableProps> = ({ alertGroups, onAddGroup, onEditGroup, onDeleteGroup }) => {
  return (
    <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Alert Groups</h2>
        <button onClick={onAddGroup} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          Add Group
        </button>
      </div>
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3">Name</th>
            <th scope="col" className="px-6 py-3">Sensors</th>
            <th scope="col" className="px-6 py-3">Recipients</th>
            <th scope="col" className="px-6 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {alertGroups.map((group) => (
            <tr key={group.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td className="px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">{group.name}</td>
              <td className="px-6 py-4">{group.sensorIds.length}</td>
              <td className="px-6 py-4">{group.recipients.length}</td>
              <td className="px-6 py-4">
                <button onClick={() => onEditGroup(group)} className="text-blue-600 dark:text-blue-500 hover:underline">Edit</button>
                <button onClick={() => onDeleteGroup(group.id)} className="text-red-600 dark:text-red-500 hover:underline ml-4">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RemoteAlertGroupTable; 